import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import ToastContainer from './ToastContainer';

const Layout = ({ children }) => {
  return (
    <Container fluid className="bg-light">
      <Row>
        <Col md={3} lg={2} className="p-0">
          <Sidebar />
        </Col>
        <Col md={9} lg={10} className="p-4">
          {children}
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default Layout;